// extracted by mini-css-extract-plugin
module.exports = {"container":"Nd-z","heading":"Od-z","links":"Pd-z","linkBtn":"Qd-z","disabled":"Rd-z","linkUppercaseBold":"Sd-z","copy":"Td-z","subCopy":"Ud-z"};